import { Box, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import speaker from '../../Announcement/images/speaker.png';

const sizeConfig = { base: '2.5em', md: '3.2em', xl: '4em' };

/**
 * @description: 公告按鈕組件
 * @return {JSX.Element}
 */
const AnnouncementButton = () => {
  const navigate = useNavigate();
  const handleOnClick = () =>
    navigate('?announcement_open=true', { replace: true });
  return (
    <Box
      onClick={handleOnClick}
      cursor="pointer"
      minWidth={{ ...sizeConfig }}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Image
        src={speaker}
        alt="Announcement Speaker"
        display={{ base: 'block', sm: 'block' }}
        height={sizeConfig}
        width={sizeConfig}
      />
    </Box>
  );
};
export default AnnouncementButton;
